import React from "react";
import Select from "react-select";

type Props = {
	value: string,
	updateConfig: Function
}

const VideoFilter = (props: Props) => {
	const metrics = [
		{ label: "Select...", value: "" },
		{ label: "Stories with video", value: "with_video" },
		{ label: "Stories without video", value: "without_video" },
	];

	return (
		<div className="form-group">
			<label htmlFor="metricType">Video:</label>
			<Select
				id="metricType"
				className="basic-single"
				classNamePrefix="so-select-metric-type"
				value={props.value ? metrics.find(item => item.value === props.value) : null}
				options={metrics}
				onChange={e => props.updateConfig(['video_filter'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
			/>
		</div>
	);
};

export default VideoFilter;
